import styled from 'styled-components';
import {
  Paper,
  FormControl,
  FormLabel,
} from '@mui/material';

import colors from '../../../../../../styles/colors';

const StyledPaper = styled(Paper)`
  padding: 16px;
  max-width: 900px;
`;

const StyledFormControl = styled(FormControl)`
  display: flex;
  flex-direction: row;
  margin: 0 0 20px;
  justify-content: space-between;
`;

const StyledFormLabel = styled(FormLabel)`
  margin: 8px 0;
`;

const Container = styled.div`
  margin: 10px 0;
`;

const OptionsContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const AmendmentWarning = styled.div`
  font-weight: 600;
  font-size: 14px;
  color: ${colors.shades.danger1};
  margin: 10px 0 20px 0;
`;

export {
  StyledPaper,
  StyledFormControl,
  StyledFormLabel,
  Container,
  OptionsContainer,
  AmendmentWarning,
};
